import React, { useEffect, useRef } from "react";
import { RichTextEditor, Link } from "@mantine/tiptap";
import { useEditor } from "@tiptap/react";
import Highlight from "@tiptap/extension-highlight";
import StarterKit from "@tiptap/starter-kit";
import Underline from "@tiptap/extension-underline";
import TextAlign from "@tiptap/extension-text-align";
import Superscript from "@tiptap/extension-superscript";
import SubScript from "@tiptap/extension-subscript";
import { Box, Text, Input } from "@mantine/core";

import _ from "lodash";
const TextEditor = ({ form, name, readOnly = false, label = "", mt = 0 }) => {
  const content = _.get(form.values, name);
  let editor = useEditor({
    extensions: [
      StarterKit,
      Highlight,
      Underline,
      TextAlign,
      Superscript,
      SubScript,
      Link.configure({
        openOnClick: false,
        HTMLAttributes: {
          target: "_blank",
          rel: "noopener noreferrer",
        },
      }),
    ],
    content,
    onUpdate: ({ editor }) => {
      //   onChange("paymentInfo", editor.getHTML());
      form.setFieldValue(name, editor.getHTML());
    },
  });

  const appliedContent = useRef(null);
  useEffect(() => {
    if (!editor || editor.isFocused) return;
    const next = content || "";
    if (appliedContent.current === next) return;
    if (!next && editor.isEmpty) {
      appliedContent.current = next;
      return;
    }
    if (editor.getHTML() === next) {
      appliedContent.current = next;
      return;
    }
    editor.commands.setContent(next);
    appliedContent.current = next;
  }, [editor, content]);

  return (
    <>
      <Box mt={mt}>
        {label && <Input.Wrapper label={label}></Input.Wrapper>}
        {!editor ||
          (readOnly && (
            <div
              className="mantine-tiptap"
              dangerouslySetInnerHTML={{
                __html: _.get(content, "html", content),
              }}
            />
          ))}

        {editor && !readOnly && (
          <RichTextEditor editor={editor} contentEditable={false}>
            <RichTextEditor.Toolbar sticky stickyOffset={60}>
              <RichTextEditor.ControlsGroup>
                <RichTextEditor.Bold />
                <RichTextEditor.Italic />
                <RichTextEditor.Underline />
                <RichTextEditor.Strikethrough />
                <RichTextEditor.ClearFormatting />
                <RichTextEditor.Highlight />
                <RichTextEditor.Code />
              </RichTextEditor.ControlsGroup>

              <RichTextEditor.ControlsGroup>
                <RichTextEditor.H1 />
                <RichTextEditor.H2 />
                <RichTextEditor.H3 />
                <RichTextEditor.H4 />
              </RichTextEditor.ControlsGroup>

              <RichTextEditor.ControlsGroup>
                <RichTextEditor.Blockquote />
                <RichTextEditor.Hr />
                <RichTextEditor.BulletList />
                <RichTextEditor.OrderedList />
                <RichTextEditor.Subscript />
                <RichTextEditor.Superscript />
              </RichTextEditor.ControlsGroup>

              <RichTextEditor.ControlsGroup>
                <RichTextEditor.Link />
                <RichTextEditor.Unlink />
              </RichTextEditor.ControlsGroup>

              <RichTextEditor.ControlsGroup>
                <RichTextEditor.AlignLeft />
                <RichTextEditor.AlignCenter />
                <RichTextEditor.AlignJustify />
                <RichTextEditor.AlignRight />
              </RichTextEditor.ControlsGroup>
            </RichTextEditor.Toolbar>

            <RichTextEditor.Content />
          </RichTextEditor>
        )}
      </Box>
    </>
  );
};

export default TextEditor;
